<div class="dialog" [class.blocked]="isBlocked">
    <!-- Blocking overlay when external changes were detected -->
    <div *ngIf="isBlocked" class="blocking-overlay">
        <div class="blocking-message">
            <icc-icon name="warning" class="warning-icon"></icc-icon>
            <p>{{ 'COMPLAINT|Reklamacja została zmodyfikowana przez innego użytkownika. Dane w tym oknie są nieaktualne i zostały zablokowane do edycji. Zamknij okno i otwórz ponownie, aby zobaczyć aktualne dane.' | translate }}</p>
            <div class="blocking-actions">
                <button iccButton appearance="primary" (click)="close()">
                    {{ 'INTERFACE|Zamknij' | translate }}
                </button>
            </div>
        </div>
    </div>

    <div class="dialog-header">
        <h3 *ngIf="data.userType === 'authorizedRetailer'">{{ 'COMPLAINT|Lista sprzedawców (APS)' | translate }}</h3>
        <h3 *ngIf="data.userType === 'distributor'">{{ 'COMPLAINT|Lista dystrybutorów' | translate }}</h3>

        <button
            iccIconButton
            (click)="close()"
            appearance="flat"
        >
            <icc-icon name="close"></icc-icon>
        </button>

    </div>
    <div class="dialog-tools search-form">
        <div class="flex-horizontal" *ngIf="mobileView">
            <div class="w-100">
                <label iccLabel>{{ 'INTERFACE|Wyszukaj (min. 3 znaki)' | translate }}</label>
                <icc-input
                    #searchInput
                    type="text"
                    [value]="searchCombined"
                    minLength="3"
                    maxLength="100"
                    [supportText]="'COMPLAINT|Nazwa kontrahenta, e-mail, nr tel., osoba kontaktowa, NIP, adres (min. 3 znaki)' | translate"
                    (valueChange)="searchCombined = $event"
                    (keyup.enter)="handleSearch()"
                ></icc-input>
            </div>
        </div>
        <div class="flex-horizontal" *ngIf="!mobileView">
            <div class="w-100">
                <label iccLabel>{{ 'INTERFACE|Wyszukaj (min. 3 znaki)' | translate }}</label>
                <icc-input
                    #searchInput
                    type="text"
                    [value]="searchWord"
                    minLength="3"
                    maxLength="100"
                    [supportText]="'COMPLAINT|Nazwa kontrahenta, e-mail, nr tel. (min. 3 znaki)' | translate"
                    (valueChange)="searchWord = $event"
                ></icc-input>
            </div>
        </div>
        <div class="flex-horizontal">
            <div div class="fg-4 pr-1" *ngIf="!mobileView">
                <label iccLabel>{{ 'COMPANY|NIP/VAT UE' | translate }}</label>
                <icc-input
                    #searchNipInput
                    type="text"
                    [value]="searchNip"
                    minLength="3"
                    maxLength="100"
                    (valueChange)="searchNip = $event"
                    [supportText]="'COMPANY|Numer podatkowy (min. 3 znaki)' | translate"
                ></icc-input>
            </div>
            <div class="fg-4 pr-1 " *ngIf="!mobileView">
                <label iccLabel>{{ 'CONTACT|Adres' | translate }}</label>
                <icc-input
                    #searchNipInput
                    type="text"
                    [value]="searchAddress"
                    minLength="3"
                    maxLength="100"
                    (valueChange)="searchAddress = $event"
                    [supportText]="'CONTACT|Miejscowość, kod pocztowy lub adres (min. 3 znaki)' | translate"
                ></icc-input>
            </div>
            <div class="fg-1 pt-1">
                <button
                    iccButton
                    class="right"
                    (click)="handleSearch()"
                >
                    <icc-icon name="search"></icc-icon>
                    {{ 'INTERFACE|Wyszukaj' | translate }}
                </button>
            </div>
        </div>
    </div>

    <div class="dialog-body dialog-list">
        <table  *ngIf="!mobileView">
            <thead>
                <tr>
                    <th>{{ 'INTERFACE|Nazwa' | translate }}</th>
                    <th>{{ 'COMPANY|NIP / VAT-UE' | translate }}</th>
                    <th>{{ 'COMPANY|Lokalizacja' | translate }}</th>
                    <th>{{ 'CONTACT|E-mail / Nr tel.' | translate }}</th>
                    <th></th>
                </tr>

            </thead>
            <tbody>
                <tr *ngFor="let contractor of contractors | paginate: { itemsPerPage: recordsOnPage, currentPage: page } " >
                    <td >{{contractor?.companyName}}</td>
                    <td >
                        {{contractor?.companyVatNr}}
                        <ng-container *ngIf="contractor?.companyVatNrEu">
                            / {{contractor.companyVatNrEu}}
                        </ng-container>
                    </td>
                    <td >
                        {{ contractor.address }}
                    </td>
                    <td >
                        {{ contractor.email }}
                        <ng-container *ngIf="contractor?.phoneNumber">
                            / {{contractor.phoneNumber}}
                        </ng-container>
                    </td>
                    <td class="dialog-actions" >
                        <button
                            iccIconButton
                            (click)="select(contractor)"
                            appearance="flat"
                        >
                            <icc-icon name="done"></icc-icon>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
        <div *ngIf="mobileView" class="client-card-list">
            <div *ngFor="let contractor of contractors | paginate: { itemsPerPage: recordsOnPage, currentPage: page } " class="client-card" (click)="select(contractor)">
                <p class="client-card__header">{{ contractor?.companyName }}</p>
                <p>
                    <span class="text-uppercase">{{ 'COMPANY|NIP' | translate }}:</span>
                    <span>
                        {{ contractor?.companyVatNr }}
                        <ng-container *ngIf="contractor?.companyVatNrEu && contractor?.companyVatNrEu !== contractor?.companyVatNr">
                            / {{ contractor.companyVatNrEu }}
                        </ng-container>
                    </span>
                </p>
                <p>{{ getContractorLocalization(contractor) }}</p>
                <p>{{ getContractorEmailPhone(contractor) }}</p>
            </div>
        </div>
    </div>
    <div class="dialog-footer">

        <div class="flex-horizontal w-100">

            <pagination-controls

                (pageChange)="onChangePage($event)"
                [previousLabel]="'INTERFACE|Poprzednia' | translate"
                [nextLabel]="'INTERFACE|Następna' | translate"
                maxSize="6"

            ></pagination-controls>

        </div>
    </div>


</div>
<div
    class="curtain"
    (click)="close()"
></div>
